/* ─────────────────────────────────────────────
   PeopleSuiteNavbar.constants.ts
   Shared constants for the navbar component
───────────────────────────────────────────── */

/* ── Defaults ── */
export const DEFAULT_PAGE_NAME = 'Dashboard';
export const DEFAULT_USER_NAME = 'User';
export const DEFAULT_USER_EMAIL = '';
export const DEFAULT_USER_ROLE = '';
export const DEFAULT_NOTIF_DOT_COLOR = '#2B9BA5';

/* ── Date formatting ── */
export const WEEKDAY_NAMES: string[] = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const MONTH_NAMES_SHORT: string[] = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

/* ── Timing (ms) ── */
export const TOAST_DISPLAY_DURATION_MS = 2500;
export const TOAST_EXIT_ANIMATION_MS = 500;
export const DATE_REFRESH_INTERVAL_MS = 60000;
export const GLOW_START_DELAY_MS = 500;

/* ── Custom DOM events ── */
export const EVENT_SIDEBAR_TOGGLE = 'ps:sidebar:toggle';
export const EVENT_NAV_CLICK = 'ps:nav:click';

/* ── Toast icons ── */
export const TOAST_ICON_NOTIFICATIONS = 'notifications';
export const TOAST_ICON_SIGN_OUT = 'logout';
export const TOAST_ICON_DEFAULT = 'info';

/* ── Toast messages ── */
export const TOAST_MSG_NOTIF_OPENED = 'Notifications opened';
export const TOAST_MSG_SIGNING_OUT = 'Signing out…';

/* ── Role labels ── */
export const ROLE_LABEL_SUPER_ADMIN = 'Super Admin';

import { formatRoleLabel as sharedFormatRoleLabel } from '@hrms/shared';

export function formatRoleLabel(userRole: string): string {
  if (!userRole) return DEFAULT_USER_NAME;
  return sharedFormatRoleLabel(userRole);
}

/* ── DOM ids used when mounting/querying the navbar ── */
export const DOM_ID = {
  hamburgerBtn: 'ps-hamburger-btn',
  breadcrumbHome: 'ps-breadcrumb-home',
  breadcrumbActive: 'ps-breadcrumb-active',
  date: 'ps-date',
  bellBtn: 'ps-bell-btn',
  bellBadge: 'ps-bell-badge',
  notifDropdown: 'ps-notif-dropdown',
  notifBody: 'ps-notif-body',
  avatarBtn: 'ps-avatar-btn',
  profileDropdown: 'ps-profile-dropdown',
  profileItem: 'ps-profile-item',
  signOutItem: 'ps-signout-item',
  toastContainer: 'ps-toast-container',
  navBrand: 'navBrand',
} as const;
